<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">فرم ثبت اطلاعات کالا</h5>
    <form [formGroup]="AddNewProduct" (submit)="SubmitAddNewProduct()">

      <input type="hidden" formControlName="id" />

      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">عنوان</label>
          <input formControlName="Title" type="text" class="form-control" placeholder="اینجا تایپ کنید ...">
          <small *ngIf="!get_Form_Title().valid && get_Form_Title().touched"
            class="form-text text-muted MyErrorRedColor">عنوان را وارد نمائید.</small>
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1"><button type="button" (click)="openModal_ProductGroup(templateProductGroup)" class="btn btn-danger left"> انتخاب  گروه کالا  <i class="fa fa-object-ungroup"></i> </button> </label>
          <input type="text" class="form-control" disabled value="{{Data_Seleted_Record.title}}" />
        </div>
      </div>
      <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
      <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewProduct.valid" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>
      <button *ngIf="!InProccessing" type="reset" class="btn btn-danger" style="margin-left: 5px;"><i
          class="fa fa-times-rectangle"></i> لغو </button>
      <button routerLink="/Product" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i
          class="fa fa-mail-reply"></i> بازگشت </button>
    </form>
  </div>
</div>



<ng-template #templateProductGroup>
  <div class="modal-header">
     <h4 class="modal-title pull-left">لیست اطلاعات  گروه کالا  </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ProductGroup.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-body">
    <div class="card-body">
      <div class="row">
        <div class="form-group col-md-12">
            <label for="exampleInputEmail1"> عنوان گروه کالا </label>
            <input  type="text" class="form-control"  [(ngModel)]="Search_Name_ProductGroup_Table"  placeholder="برای جستجو اینجا تایپ کنید ...">
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>عنوان</th>
              <th>امکانات</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_ProductGroup
            |filter:Search_Name_ProductGroup_Table:'title'
            | paginate
                    : {
                        id: 'DataList_ProductGroup',
                        itemsPerPage: 10,
                        currentPage: page,
                        totalItems: (DataList_ProductGroup|filter:Search_Name_ProductGroup_Table:'title').length
                      }">
              <td>{{DataList_ProductGroup.indexOf(item)+1}}</td>
              <td>{{item.title}}</td>
              <td (click)="Set_Selected_ProductGroup_Record(item)" style="cursor: pointer;">
                <button class="btn btn-info"><i class="fa fa-check"></i> انتخاب</button>
              </td>

            </tr>
          </tbody>
        </table>
    </div>
  </div>

 </div>
  <div class="modal-footer">
    <img *ngIf="ProcssingProductGroup" src="assets/Loading.gif" style="width: 25px;" />
    <button  *ngIf="!ProcssingProductGroup" type="button" (click)="ReadData_ProductGroup()"  class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-search"></i> جستجوی اطلاعات </button>
     <button type="button" class="btn btn-danger" (click)="modalRef_ProductGroup.hide()">بستن</button>
  </div>
</ng-template>